import PromoApi from '../utils/config/apiPromobooster'
import {envVariables} from '../utils/envVariables/envVariables'
import {getAccessToken} from '../utils/authSession'

export const approveCatalogFromHome = (catalog) => PromoApi.post(
  `${envVariables.baseUrl}/promotion/approve/home`,
  {
    id: catalog.id_promo,
    estado_promocional_actual: catalog.estado_promocional,
  },
  {headers: {Authorization: `Bearer ${getAccessToken()}`}},
)
